import { type Roles } from 'shared/types'

export const deriveRoles = (
  actions: string[] = [],
  paymentProfiles?: { id: string }[],
  hasPaymentAccount?: boolean
): Roles => ({
  acquirer: paymentProfiles ? Boolean(paymentProfiles.length) : actions?.includes('acquireraffiliation:read'),
  banking: hasPaymentAccount || actions?.includes('paymentaccount:read'),
  credit: actions?.includes('paymentaccount:read') && actions?.includes('paymentaccount:loans')
})
